import React from 'react';
import styles from './Video.module.css';

type VideoProps = {
  item: {
    url?: string;
    alternativeText?: string;
    video: {
      url: string;
      alternativeText: string;
    };
  };
};

export default function Video({ item }: VideoProps) {
  const videoUrl = item.url || item.video?.url || '';
  return (
    <video className={styles.videoArticle} controls width="100%">
      <source src={videoUrl} type="video/webm" />
      <source src={videoUrl} type="video/mp4" />
    </video>
  );
}
